import { FullPropertySearch } from '__generated__/api';
import {
  LoyaltyEducation,
  LoyaltyEducationAction,
  LoyaltyEducationContent,
  LoyaltyEducationContentType,
  LoyaltyEducationPerks,
  LoyaltyPointsEducation,
  LoyaltyProgramEducation
} from 'models/common/loyalty-education';

export const mapLoyaltyEducation = (query: FullPropertySearch.Query): LoyaltyEducation | null => {
  const loyaltyEducation = query.propertySearch.summary.loyaltyEducation;
  if (!loyaltyEducation) {
    return null;
  }

  return {
    title: loyaltyEducation.title,
    content: mapLoyaltyEducationContent(loyaltyEducation.content),
    action: mapLoyaltyEducationAction(loyaltyEducation.action)
  };
};

const mapLoyaltyEducationAction = (action: FullPropertySearch._Action): LoyaltyEducationAction | null => {
  if (!action) {
    return null;
  }

  return {
    text: action.text,
    rfrr: action.rfrr,
    href: action.href
  };
};

const mapLoyaltyEducationContent = (content: FullPropertySearch.Content): LoyaltyEducationContent | null => {
  if (!content) {
    return null;
  }
  switch (content.__typename) {
    case 'LoyaltyPointsEducation':
      return mapLoyaltyPointsEducation(content);
    case 'LoyaltyProgramEducation':
      return mapLoyaltyProgramEducation(content);
    default:
      return null;
  }
};

const mapLoyaltyProgramEducation = (
  programEducation: FullPropertySearch.LoyaltyProgramEducationInlineFragment
): LoyaltyProgramEducation => ({
  _type: LoyaltyEducationContentType.PROGRAM,
  perks: mapLoyaltyPerks(programEducation.perks),
  joinProgramText: programEducation.joinProgramText
});

const mapLoyaltyPointsEducation = (pointsEducation: FullPropertySearch.LoyaltyPointsEducationInlineFragment): LoyaltyPointsEducation => ({
  _type: LoyaltyEducationContentType.POINTS,
  description: pointsEducation.description,
  programFeatures: pointsEducation.programFeatures.map(feature => ({
    title: feature.title,
    description: feature.description,
    perks: mapLoyaltyPerks(feature.perks)
  }))
});

const mapLoyaltyPerks = (perks: FullPropertySearch.Perks | FullPropertySearch._Perks): LoyaltyEducationPerks | null => {
  if (!perks) {
    return null;
  }

  return {
    descriptions: perks.descriptions,
    icon: perks.icon
  };
};
